import { render } from "./validator.vue?vue&type=template&id=3a35391a&scoped=true&ts=true"
import script from "./validator.vue?vue&type=script&lang=ts"
export * from "./validator.vue?vue&type=script&lang=ts"

import "./validator.vue?vue&type=style&index=0&id=3a35391a&lang=scss&scoped=true"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a35391a"]])

export default __exports__